"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
var ThemeProvider_1 = require("../lib/ThemeProvider");
var Text_1 = require("./Text");
function useTheme() {
    var theme = ThemeProvider_1.useStyles().theme;
    return theme;
}
exports.Text = Text_1.createText({ useTheme: useTheme }).Text;
//# sourceMappingURL=TextBase.js.map